<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <form @submit.prevent>
        <b-overlay :show="isLoading" class="rounded" variant="transparent">
          <template #overlay>
            <b-img
              width="100"
              :src="require('@/assets/img/brand/loader.gif')"
              alt=""
            />
          </template>
          <div class="card bg-secondary shadow border-0 rounded">
            <div class="card-header bg-transparent pb-3">
              <div class="text-muted text-center mt-2">
                <h3>{{ $t("login") }}</h3>
                <img src="favicon.png" class="icon-app" alt="" />
              </div>
            </div>
            <div class="card-body px-lg-5 py-lg-5">
              <base-input
                class="input-group-alternative border mb-3"
                :placeholder="$t('email')"
                data-vv-validate-on="blur"
                v-validate="'required'"
                name="email"
                :data-vv-as="$t('email')"
                addon-left-icon="ni ni-email-83"
                v-model="model.email"
              >
              </base-input>
              <span class="text-danger text-sm" v-show="errors.has('email')"
                ><small>{{ errors.first("email") }}</small></span
              >
              <base-input
                class="input-group-alternative border"
                :placeholder="$t('password')"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                data-vv-validate-on="blur"
                v-validate="'required|min:7|max:20'"
                :data-vv-as="$t('password')"
                name="password"
                ref="password"
                v-model="model.password"
              >
              </base-input>
              <span class="text-danger text-sm" v-show="errors.has('password')"
                ><small>{{ errors.first("password") }}</small></span
              >

              <div class="text-center">
                <base-button
                  type="primary"
                  class="my-4"
                  @click="referrer ? msgConfirm() : login()"
                  >{{ $t("login") }}</base-button
                >
              </div>
              <div class="text-center">
                <b-link
                  @click="$router.push({ name: 'terms-of-service' })"
                  target="_blank"
                >
                  {{ $t("conditions") }}</b-link
                >
              </div>
            </div>
          </div>
        </b-overlay>
        <div class="row mt-3">
          <div class="col-5">
            <router-link to="/forgot-password" class="text-light">
              <small> {{ $t("forgot_password") }}</small>
            </router-link>
          </div>
          <div class="col-7 text-right">
            <small class="text-light">{{ $t("not_account") }}</small>
            <router-link to="/register" class="text-light">
              <small> {{ $t("sign_up") }}</small>
            </router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import helpers from "@/services/helpers";
export default {
  name: "login",
  created() {
    if (localStorage.getItem("ref")) {
      this.referrer = localStorage.getItem("ref");
    }
    if (process.env.NODE_ENV == "development") {
      this.model = {
        email: "nextstation.cl@gmail.com",
        password: "buendia",
      };
    }
  },
  data() {
    return {
      model: {
        email: "",
        password: "",
      },
      referrer: "",
      autorize: false,
    };
  },
  methods: {
    ...mapActions({
      setLogin: "login",
    }),
    async login() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        const res = await this.setLogin(this.model);
        if (this.check && res.status === 200) {
          if (localStorage.getItem("ref") && this.autorize) {
            const data = await axios.post("/api/add-referred-user", {
              referring_code: this.referrer,
            });
            if (data.status) {
              localStorage.removeItem("ref");
            }
          }
          this.$router.push({ name: "dashboard" });
        }
      }
    },
    msgConfirm() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          `${this.$t("message_confirm_referrer")} ${this.referrer}`,
          {
            title: this.$t("please_confirm_referrer"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: this.$t("yes"),
            cancelTitle: this.$t("not"),
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.autorize = true;
          } else {
            this.autorize = false;
          }
          this.login();
        })
        .catch((err) => {
          console.log(err);
          helpers.handleError(err);
        });
    },
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
      check: "check",
    }),
  },
};
</script>
<style scope>
.icon-app {
  max-height: 7rem;
}
</style>
